/* eslint-disable */
import React, { useState } from "react";
import { RecoilRoot } from "recoil";
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import { CookiesProvider } from "react-cookie";

// import { initialXSRFToken } from "./services/auth";
import Remitter from "./pages/remitter";
import Review from "./pages/review";
import FxRates from "./pages/fxRates";
import HistoryPage from "./pages/history";
import Margin from "./pages/margin";
import PrivateRoute from "./hoc/PrivateRoute";
import UserDocuments from "./pages/userDocuments/index";
import Homepage from "./pages/home";
import { TransferPhaseLayout } from "./components/layout";
import { PickRecipient } from "./pages/pickRecipient";
import { ConfirmationPage } from "./pages/confirmation/index";
import Amount from "./pages/remittance";
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import { RecipientDetails } from "./pages/recipientDetails";
import Payment from "./pages/payment";
import SubVendor from "./pages/subVendor";
import { PurposeCodePage } from "./pages/purposeCode";
import { UserDetailsPage } from "./pages/user-details";
import { RecipientProfile } from "./pages/recipientProfile";
import { OfflineTransferPhaseLayout1 } from "./components/layout/OfflineTransferPhasebarLayout/SBM";
// import OfflineSBMAmount from "./pages/offline-old/sbm/remittance";
import { OfflineSBMRemitter } from "./pages/offline-old/sbm/remitter";
import { OfflineSBMPickRecipient } from "./pages/offline-old/sbm/pickRecipient";
import { OfflineSBMRecipientDetails } from "./pages/offline-old/sbm/recipientDetails";
import { OfflineSBMDocuments } from "./pages/offline-old/sbm/documents";
import { OfflineTransferPhaseLayout2 } from "./components/layout/OfflineTransferPhasebarLayout/WesternUnion";
import OfflineSBMReview from "./pages/offline-old/sbm/review";
import { OfflineWURemitter } from "./pages/offline-old/westernUnion/remitter";
import { OfflineWUDocuments } from "./pages/offline-old/westernUnion/documents";
import { OfflineFlywireRemittancePage } from "./pages/offline-old/flywire/remittance";
import { OfflineTransferPhaseLayout3 } from "./components/layout/OfflineTransferPhasebarLayout/Flywire";
import { OfflineFlywireRemitterPage } from "./pages/offline-old/flywire/remitter";
import { OfflineFlywireDocumentPage } from "./pages/offline-old/flywire/documents";
import OfflineWURemittance from "./pages/offline-old/westernUnion/remittance";
import MobileVerification from "./pages/remitter/MobileVerification";
import { isMasterVendor } from "./store";
import { Mixpanel } from "./constants/mixpanel";
import Flywire from "./pages/flywire";
import Offline from "./pages/offline";
import TravelCard from "./pages/travel-card";
import ConveraPaymentPage from "./pages/convera/[uid]";
import Convera from "./pages/convera";

function App() {
  Mixpanel.initialize();

  const generatedUDID = sessionStorage.getItem("generatedUDID");

  return (
    <CookiesProvider>
      <RecoilRoot>
        <Router>
          <Routes>
            <Route path="/auth/sign-in" element={<SignIn />} />
            <Route path="/auth/sign-up" element={<SignUp />} />
            <Route path="/mobileverification" element={<MobileVerification />} />
            <Route path="/" element={<PrivateRoute />}>
              <Route path="/" element={<SignIn />} />
              <Route path="/home" element={<Homepage />} />
              <Route path="/fxrates" element={<FxRates />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/margin" element={<Margin />} />
              <Route path="/confirmation" element={<ConfirmationPage />} />
              {isMasterVendor && <Route path="/subvendor-margin" element={<SubVendor />} />}
              <Route path="/" element={<TransferPhaseLayout />}>
                <Route path="/remittance" element={<Amount />} />
                <Route path="/recipient-profile" element={<RecipientProfile />} />
                <Route path="/pick-recipient" element={<PickRecipient />} />
                <Route path="/remitter" element={<Remitter />} />
                <Route path="/documents" element={<PurposeCodePage />} />
                <Route path="/user-details" element={<UserDetailsPage />} />
                <Route path="/recipient-details" element={<RecipientDetails />} />
                <Route path="/review" element={<Review />} />
                <Route path="/payment" element={<Payment />} />
                <Route path="/user-documents" element={<UserDocuments />} />
              </Route>
              <Route path="/" element={<OfflineTransferPhaseLayout1 />}>
                {/* <Route path="/1/remittance" element={<OfflineSBMAmount />} /> */}
                <Route path="/1/remitter" element={<OfflineSBMRemitter />} />
                <Route path="/1/pick-recipient" element={<OfflineSBMPickRecipient />} />
                <Route path="/1/recipient-details" element={<OfflineSBMRecipientDetails />} />
                <Route path="/1/documents" element={<OfflineSBMDocuments />} />
                <Route path="/1/review" element={<OfflineSBMReview />} />
              </Route>
              <Route path="/" element={<OfflineTransferPhaseLayout2 />}>
                <Route path="/2/remittance" element={<OfflineWURemittance />} />
                <Route path="/2/remitter" element={<OfflineWURemitter />} />
                <Route path="/2/documents" element={<OfflineWUDocuments />} />
              </Route>
              <Route path="/" element={<OfflineTransferPhaseLayout3 />}>
                <Route path="/3/remittance" element={<OfflineFlywireRemittancePage />} />
                <Route path="/3/remitter" element={<OfflineFlywireRemitterPage />} />
                <Route path="/3/documents" element={<OfflineFlywireDocumentPage />} />
              </Route>
              <Route path="/flywire" element={<Flywire transactionMode="flywire" />} />
              <Route path="/offline" element={<Offline transactionMode="offline" />} />
              <Route path="/travel-card" element={<TravelCard transactionMode="travelCard" />} />
              <Route path="/convera" element={<Convera/>} />
              <Route path={`/convera/:uid`} element={<ConveraPaymentPage />} />
            </Route>
          </Routes>
        </Router>
      </RecoilRoot>
    </CookiesProvider>
  );
}

export default App;
